export enum FreightlancerMembershipDetailsModalResponse {
  Agreed,
  Cancelled,
}
